module.exports = __webpack_public_path__ + "teqbahn-assets/media/4.c6a91713.jpg";